import split from 'lodash/split';
export const _split = split;
